import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/shared/Footer";
import { Avatar, Box, Grid, Icon, Typography, colors } from "@mui/material";
import { AppColors } from "../common/AppColors";
import { Images } from "../common/Images";
import { CheckOutlined } from "@mui/icons-material";

export const QuoteAcceptedPage: React.FC = () => {
  return (
    <>
      <Header />
      <Grid container spacing={2} justifyContent="center">
        <Box
          height="50vh"
          width="100%"
          sx={{
            backgroundImage: `url(${Images.windowsWallpaper})`,
            backgroundSize: "81% 190%",
          }}
          position="relative"
          display="flex"
          alignItems="center"
        >
          {/* Glassmorphism Background Box */}
          <Box
            bgcolor={AppColors.White}
            sx={{
              margin: "auto",
              left: "0",
              right: "0",
              position: "absolute",
              width: { xs: "90%", md: "60vw" },
              maxWidth: "700px",
              height: "35vh",
              opacity: "0.5",
              background: "rgba(255, 255, 255, 0.24)",
              borderRadius: "16px",
              boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
              backdropFilter: "blur(5px)",
              WebkitBackdropFilter: "blur(5px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
            }}
          ></Box>

          {/* Content Box */}
          <Box
            position="absolute"
            color={AppColors.White}
            textAlign="center"
            width={{ xs: "90%", md: "60vw" }}
            maxWidth="700px"
            left={0}
            right={0}
            margin="auto"
          >
            <Avatar
              sx={{
                bgcolor: colors.green[500],
                margin: "auto",
                width: 56,
                height: 56,
              }}
            >
              <CheckOutlined fontSize="large" />
            </Avatar>
            <Typography variant="h4" mt={2}>
              Quote Accepted Successfully!
            </Typography>
            <Typography variant="subtitle1" mt={1}>
              Your order has been placed and is being processed.
            </Typography>
            <Typography variant="subtitle1">
              You will receive a confirmation email shortly.
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Footer />
    </>
  );
};
